<template>
  <div class="tw-mt-5 tw-mb-5 tw-mr-9">
    <base-advanced-select
      label="Rx Items"
      placeholder="Select one or more Rx Items"
      :options="groupedAndSortedRxItems"
      v-model="selectedRxItems"
      label-key="name"
      value-key="businessRxItemId"
      multiple
      :required="required && selectedRxItems.length === 0"
      class="tw-flex-grow"
    />
  </div>
</template>

<script>
import { cloneDeep, orderBy } from "lodash";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    allRxItems: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
  },
  data() {
    return {
      selectedRxItems: [],
    };
  },
  computed: {
    groupedAndSortedRxItems() {
      const options = [];
      const groups = [...new Set(this.allRxItems.map((item) => item.productGroup))];

      groups.forEach((g) => {
        options.push({ name: g, isHeader: true });
        options.push(...orderBy(this.allRxItems.filter((p) => p.productGroup === g), ["name"]));
      });

      return options;
    },
  },
  watch: {
    selectedRxItems: {
      handler(newItems) {
        const copy = cloneDeep(this.value || {});
        copy.rxItems = newItems;
        this.$emit("input", copy);
      },
      deep: true,
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.selectedRxItems = Array.isArray(newValue && newValue.rxItems) ? newValue.rxItems : [];
      },
    },
  },
};
</script>
